import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import IslandCard from "./island-card"

import "../css/places.css"

const Places = () => {
  const { islands } = useStaticQuery(
    graphql`
      query {
        islands: allMarkdownRemark(
          filter: {
            frontmatter: {
              slug: { in: ["paros", "naxos", "mykonos", "tinos"] }
            }
          }
        ) {
          nodes {
            frontmatter {
              name
              slug
              heading
              headingImage {
                childImageSharp {
                  gatsbyImageData(
                    quality: 85
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                  )
                }
              }
            }
          }
        }
      }
    `
  )

  const places = islands.nodes.map(island => {
    return {
      name: island.frontmatter.name,
      description: island.frontmatter.heading,
      image: island.frontmatter.headingImage.childImageSharp.gatsbyImageData,
      link: `/islands/${island.frontmatter.slug.toLowerCase()}`,
    }
  })

  // sort places to always have Paros first, and Naxos second

  places.sort((a, b) => {
    if (a.name === "Paros") {
      return -1
    }
    if (b.name === "Paros") {
      return 1
    }
    if (a.name === "Naxos") {
      return -1
    }
    if (b.name === "Naxos") {
      return 1
    }
    return 0
  })

  return (
    <div className="places-container">
      {places.map((place, index) => {
        return (
          <IslandCard
            key={index}
            name={place.name}
            description={place.description}
            image={place.image}
            link={place.link}
            index={index}
          />
        )
      })}
    </div>
  )
}

export default Places
